<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  showMessage: boolean
  message?: string
  size?: string
  strokeWidth?: string
  animationDuration?: string
  fontSize?: 'xs' | 'sm' | 'md' | 'lg'
}

const props = defineProps<Props>()

const fontSizeClass = computed(() => {
  switch (props.fontSize) {
    case 'xs':
      return 'text-xs'
    case 'sm':
      return 'text-sm'
    case 'md':
      return 'text-base'
    case 'lg':
      return 'text-lg'
    default:
      return 'text-xl'
  }
})
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <PVProgressSpinner
      :style="{ width: size, height: size }"
      :strokeWidth="strokeWidth ?? 6"
      :animationDuration="animationDuration ?? '1s'"
    />
    <span v-if="showMessage" :class="[fontSizeClass, 'mt-4']">
      {{ message || 'Carregando informações...' }}
    </span>
  </div>
</template>
